import { SettingActions, SettingInitialState } from "redux/actions/Setting"

export const SettingReducer = (state = SettingInitialState, actions) => {
  switch (actions.type) {
    case SettingActions.GET_SETTING:
      return {
        ...state,
        list_setting: actions.payload,
      }
    case SettingActions.SET_NON_KELAS_ID:
      return {
        ...state,
        id_non_kelas: actions.payload,
      }
    case SettingActions.SET_KELAS_TIGA_ID:
      return {
        ...state,
        id_kelas_tiga: actions.payload,
      }
    case SettingActions.SET_FLOAT_PENJUALAN:
      return {
        ...state,
        float_penjualan: actions.payload,
      }
    case SettingActions.SET_JENIS_LAYANAN_IGD_ID:
      return {
        ...state,
        id_jenis_layanan_igd: actions.payload,
      }
    case SettingActions.SET_JENIS_LAYANAN_RJ_ID:
      return {
        ...state,
        id_jenis_layanan_rj: actions.payload,
      }
    case SettingActions.SET_DEFAULT_KAS_BANK:
      return {
        ...state,
        default_kas: actions.payload,
      }
    case SettingActions.SET_DEFAULT_GUDANG_FA:
      return {
        ...state,
        default_gudang_fa: actions.payload,
      }

    case SettingActions.SET_CETAK_BUTTON_RJ:
      return {
        ...state,
        cetak_button_rj: actions.payload,
      }

    case SettingActions.SET_CETAK_BUTTON_RI:
      return {
        ...state,
        cetak_button_ri: actions.payload,
      }

    case SettingActions.SET_CETAK_BUTTON_IGD:
      return {
        ...state,
        cetak_button_igd: actions.payload,
      }

    case SettingActions.SET_BUKA_TUTUP_BUTTON_RJ:
      return {
        ...state,
        buka_tutup_button_rj: actions.payload,
      }

    case SettingActions.SET_BUKA_TUTUP_BUTTON_RI:
      return {
        ...state,
        buka_tutup_button_ri: actions.payload,
      }

    case SettingActions.SET_BUKA_TUTUP_BUTTON_IGD:
      return {
        ...state,
        buka_tutup_button_igd: actions.payload,
      }

    case SettingActions.SET_CETAK_BUTTON_PENJUALAN:
      return {
        ...state,
        cetak_button_penjualan: actions.payload,
      }

    case SettingActions.SET_CETAK_BUTTON_TAGIHAN:
      return {
        ...state,
        cetak_button_tagihan: actions.payload,
      }

    case SettingActions.SET_PRINTER_ENV:
      return {
        ...state,
        printer_env: actions.payload,
      }

    case SettingActions.SET_TARIF_RS:
      return {
        ...state,
        tarif_rs: actions.payload,
      }

    case SettingActions.SET_DIALIZER:
      return {
        ...state,
        dializer: actions.payload,
      }

    case SettingActions.SET_TANDA_TANGAN_ELEKTRONIK:
      return {
        ...state,
        tanda_tangan_elektronik: actions.payload,
      }

    case SettingActions.SET_DEFAULT_CETAK_TAGIHAN_PDF:
      return {
        ...state,
        default_cetak_tagihan_pdf: actions.payload,
      }
    default:
      return state
  }
}
